import { Instagram, MessageCircle, Star, Globe } from "lucide-react";
import { useI18n } from "@/contexts/I18nContext";
import { useTenant } from "@/contexts/TenantContext";
import { Link } from "react-router-dom";

const Footer = () => {
  const { t } = useI18n();
  const { currentTenant } = useTenant();
  
  console.log('🔍 Footer - currentTenant social URLs:', {
    instagram: currentTenant?.instagramUrl,
    whatsapp: currentTenant?.whatsappUrl,
    google: currentTenant?.googleReviewsUrl,
    website: currentTenant?.websiteUrl,
  });
  
  const socialLinks = [
    {
      icon: Instagram,
      href: currentTenant?.instagramUrl || "https://www.instagram.com/savoyclinic/?igsh=cTZjZ3RhZW12dWE5",
      label: t('footer.instagram'),
      show: !!currentTenant?.instagramUrl,
    },
    {
      icon: MessageCircle,
      href: currentTenant?.whatsappUrl || "https://wa.me/971566892095?text=Hello%20Savoy%20Clinic",
      label: t('footer.whatsapp'),
      show: !!currentTenant?.whatsappUrl,
    },
    {
      icon: Star,
      href: currentTenant?.googleReviewsUrl || "https://www.google.com/search?sca_esv=e587478050f2f1b6&cs=1&sxsrf=AHTn8zpteFKt92PYXpYFG-9oc-Vl5DEqwA:1745907094386&si=APYL9bs7Hg2KMLB-4tSoTdxuOx8BdRvHbByC_AuVpNyh0x2KzfpNAM99qJVUDAVc9xm5_RN_se2ZThe8mGwiEdBd63vNlUChhAUPqzI8Jc2IG07apeDGrKsxM7nGfOJlALwBdxBBN4Be&q=Savoy+clinic+Reviews&sa=X&ved=2ahUKEwivya_hyvyMAxXngP0HHR_5GFQQ0bkNegQIIBAE#ebo=1",
      label: t('footer.google_reviews'),
      show: !!currentTenant?.googleReviewsUrl,
    },
    {
      icon: Globe,
      href: currentTenant?.websiteUrl || "https://www.savoyclinic.ae/",
      label: t('footer.website'),
      show: !!currentTenant?.websiteUrl,
    },
  ].filter(link => link.show);

  const addressParts = [
    currentTenant?.streetAddress,
    currentTenant?.city,
    currentTenant?.stateProvince,
    currentTenant?.postalCode,
    currentTenant?.country
  ].filter(Boolean);
  
  const addressString = addressParts.join(', ');

  return (
    <footer className="fixed bottom-0 left-0 right-0 bg-background border-t border-border z-50">
      <div className="max-w-[500px] mx-auto px-4 py-3">
        <nav className="flex items-center justify-around gap-4" role="navigation" aria-label="Social media links">
          {socialLinks.map((link) => {
            const Icon = link.icon;
            return (
              <a
                key={link.label}
                href={link.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={link.label}
                className="flex items-center justify-center w-11 h-11 min-w-[44px] min-h-[44px] text-muted-foreground transition-all duration-300 hover:opacity-80 hover:-translate-y-0.5 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 rounded-md"
                style={{
                  color: currentTenant?.primaryColor || '#C5A25D'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.opacity = '0.8';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.opacity = '1';
                }}
              >
                <Icon className="w-7 h-7" strokeWidth={1.5} />
              </a>
            );
          })}
        </nav>
        {currentTenant && (
          <div className="text-center mt-3 space-y-1">
            <p className="text-sm font-medium text-foreground">
              {currentTenant.name}
            </p>
            {addressString && (
              <p className="text-xs text-muted-foreground font-light">
                {addressString}
              </p>
            )}
          </div>
        )}
        <p className="text-center text-xs text-muted-foreground mt-2 font-light">
          {t('footer.copyright')}
        </p>
        <p className="text-center text-xs text-muted-foreground mt-1">
          <Link 
            to="/" 
            className="hover:text-foreground transition-colors hover:underline"
          >
            Powered by Savoy Scanner
          </Link>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
